/// <reference path="../../../node_modules/@types/jquery/index.d.ts" />

export interface SelectListItem {
    disabled: boolean;
    group: SelectListGroup;
    selected: boolean;
    value: string;
    text: string;
}

export interface SelectListGroup {
    disabled: boolean;
    name: string;
}

export class Utility {

    public static SendAntiForgery(): any {
        return { "__TOBAntiforgeryField": $('input[name=__TOBAntiforgeryField]').val() }
    }

    public static ShowCancelModal(): void {
        $('#CancelModal').data("kendoDialog").open();
    }

    public static OnOpen(): void {
        $("#cancelButton").slideUp();
        $("#submitButton").slideUp();
    }

    public static OnClose(): void {
        $("#cancelButton").slideDown();
        $("#submitButton").slideDown();
    }

    public static RedirectToHomeIndex(): void {
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/Home/Index`;
    }

    public static BindSubmitButtonHandler(jQueryIdFormName: string, jQueryIdSubmitButton): void {
        ///Continue button handles the "submit" on the page
        ///Make sure only one "click" event is processed.
        ///Note: one() will remove the click handler, so if validation fails, it needs to be reattached.
        $(jQueryIdSubmitButton).one('click', (evt) => {
            //var form = document.getElementById('index-form') as HTMLFormElement;
            //console.log($("#index-form).valid());
            if ($(jQueryIdFormName).valid()) {
                $(evt.target).slideUp();
                $("#cancelButton").slideUp();
                $(jQueryIdFormName).trigger("submit");
            } else {
                Utility.BindSubmitButtonHandler(jQueryIdFormName, jQueryIdSubmitButton);
                //enforce normal form validation behavior by scrolling up to the 1st invalid element and focusing it
                const firstInvalidElement = $(jQueryIdFormName)[0].querySelector<HTMLElement>(':invalid');
                if (firstInvalidElement) {
                    firstInvalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    firstInvalidElement.focus();
                }
            }
        });
    }

}